
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import type { ClasshourDetail as TClasshourDetail } from '@xt/client/entities/course-v2/types.d'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import Qrcode from '@xt/www/components/showQrcode/index.vue'

@Observer
@Component({
  components: {
    EmptyStatus,
    Qrcode
  }
})
export default class ClasshourWenfang extends Vue {
  @Prop({ default: () => [] }) data: TClasshourDetail['wenfangProductList']

  filterData: TClasshourDetail['wenfangProductList'] & { show: boolean }[] = []

  getPopupContainerNode(triggerNode: HTMLElement) {
    return triggerNode ?? (document.body as HTMLElement)
  }

  onMouseLeave(index: number) {
    if (this.filterData[index].show === false) return

    this.filterData[index].show = false
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  created() {
    this.filterData = this.data.map(item => ({ ...item, show: false }))
  }
  mounted() {}
  updated() {}
  destroyed() {}
}
